import { IUserConfigItem } from '@app/interfaces/user';
import { api } from './http.api';
import { configVersion } from '@app/constants/whitelist';

export const getUserRequest = async () =>
  await api.get('/web/admin/user', {
    headers: {
      'X-Api-Version': configVersion,
    },
  });

export const saveUserConfigRequest = async (config: IUserConfigItem[]) =>
  await api.post('/web/admin/user/settings', { config });

export const changePasswordRequest = async (oldPassword: string, password: string) =>
  await api.post('/web/admin/password/new-password', { oldPassword, password });
